import React from 'react';
import ServicePage from './ServicePage';

export default function GreenlineBathrooms() {
  return (
    <ServicePage
      category="bathroom"
      eyebrow="02 · Bathrooms"
      title={<>Sanctuary <em className="not-italic" style={{ color: 'var(--gl-primary)' }}>baths.</em></>}
      intro="A primary bathroom should feel like the end of the day, every day. Quiet. Warm. Slow."
      description="Curbless walk-in showers with linear drains, slab-veined Calacatta walls, custom vanities in rift-cut white oak, brass fixtures from Waterworks and Kohler Components. We handle structural reframes, full waterproofing under tile, radiant heat layouts, and the small details — like making sure the towel bar lands exactly where your hand reaches. Powder rooms welcome too — sometimes the smallest room is the boldest."
    />
  );
}
